import axios from '@/axios.js'

export default {
  getAllGroups ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Custom-Api/GetAllGroups`)
        .then((response) => {
          console.error(response)
          commit('SET_GROUP_LIST', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
